import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot } from '@angular/router';
import { Globals } from '../globals';
import { AccessToken } from './access-token';
import { AuthUtil } from './auth-util';
import { environment } from '../../environments/environment'



@Injectable({providedIn: 'root'})
export class AccessTokenGuard {

    constructor(private router: Router, private _globals: Globals) { }

    //Routes to lab page if it is not available
    canActivate(route: ActivatedRouteSnapshot) {
        
        if(!environment.AZURE_LOGIN_NEEDED) {
            return true
        }

        let token = localStorage.getItem('token')
        let util = new AuthUtil()

        if (!token || token === undefined ) {
            //this.router.navigate([''])
            util.redirectToAzureLogin()
            return false
        }

        if (token != 'in_progress') {
            let tokenObject: AccessToken = JSON.parse(token)

            if (tokenObject && tokenObject.access_token && !util.isLoginExpired()) {
                return true
                
            } else {
                //this.router.navigate([''])
                util.redirectToAzureLogin()
                return false
            }
        } 


    }
}